import Vue from 'vue'
import App from './app/App.vue'
import store from './plugins/store'
import router from './router/router'
import vuetify from './plugins/vuetify';
import './assets/theme.css'
import JsonCSV from 'vue-json-csv'
import VueRssFeed from 'vue-rss-feed';
import VueMask from 'v-mask';
import VueGraph from 'vue-graph'
import XlsxRead from "../node_modules/vue-xlsx/dist/components/XlsxRead";
import XlsxJson from "../node_modules/vue-xlsx/dist/components/XlsxJson";
import XlsxSheets from "../node_modules/vue-xlsx/dist/components/XlsxSheets";

Vue.use(VueMask);

Vue.use(VueGraph)

Vue.component('XlsxRead', XlsxRead)

Vue.component('XlsxJson', XlsxJson)

Vue.component('XlsxSheets', XlsxSheets)

Vue.component('downloadCsv', JsonCSV)

Vue.component('VueRssFeed', VueRssFeed)

Vue.config.productionTip = false

new Vue({
  VueGraph,
  JsonCSV,
  router,
  store,
  vuetify,
  VueRssFeed,
  VueMask,
  render: h => h(App)
}).$mount('#app')
